import styled from 'styled-components';

const Wrap = styled.div`
  .css-qc6sy-singleValue {
    p {
      display: none;
    }
  }
  .css-26l3qy-menu {
    z-index: 9999;
    width: 150px;
  }
  .css-6j8wv5-Input {
    input {
      color: transparent !important;
    }
  }
`;

export default { Wrap };
